import BaseComponent from "../core/base-component.js";

export default class FormField extends BaseComponent {
}
